'use strict';
window.jQuery = window.$ = require('jquery');
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
require('isotope-packery');
require('@fancyapps/fancybox');

export default class Gallery {
  constructor(el) {
    imagesLoaded.makeJQueryPlugin( $ );
    this.el = el;

    const $grid = new Isotope( el, {
      // options...
      itemSelector: '.photo',
      layoutMode: 'packery',
      masonry: {
        columnWidth: '.sizer'
      }
    });

    const reLayout = window.setInterval(() => {
      $grid.layout();
    }, 500);

    $(el).imagesLoaded(() => {
      window.clearInterval(reLayout);
      $grid.layout();
    });
  }
}
